import { useState, useEffect } from 'react';
import { collection, query, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebaseConfig';

export interface Brand {
  id: string;
  name: string;
  logoUrl: string;
  isActive: boolean;
  order?: number;
  createdAt: any;
}

export const useBrands = () => {
  const [brands, setBrands] = useState<Brand[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    try {
      const brandsRef = collection(db, 'brands');
      const q = query(brandsRef);

      const unsubscribe = onSnapshot(
        q,
        (snapshot) => {
          const brandsData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          })) as Brand[];

          // Filter active brands and sort by order field or name
          const activeBrands = brandsData
            .filter(brand => brand.isActive === true)
            .sort((a, b) => {
              if (a.order !== undefined && b.order !== undefined) {
                return a.order - b.order;
              }
              return (a.name || '').localeCompare(b.name || '');
            });

          console.log('Brands loaded:', activeBrands.length, activeBrands);
          setBrands(activeBrands);
          setLoading(false);
        },
        (err) => {
          console.error('Error fetching brands:', err);
          setError('Failed to load brands');
          setLoading(false);
        }
      );

      return () => unsubscribe();
    } catch (err) {
      console.error('Error setting up brands listener:', err);
      setError('Failed to initialize brands');
      setLoading(false);
    }
  }, []);

  return { brands, loading, error };
};
